const HealthPage = () => "OK"

export default HealthPage
